import { render, staticRenderFns } from "./user-details.vue?vue&type=template&id=2bf88d14&scoped=true"
import script from "./user-details.vue?vue&type=script&lang=js"
export * from "./user-details.vue?vue&type=script&lang=js"
import style0 from "./user-details.vue?vue&type=style&index=0&id=2bf88d14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf88d14",
  null
  
)

export default component.exports